import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import getCoordinates from './geoUtils';

import { BASE_URL } from './config';

const CreaUtente = () => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const [categorie, setCategorie] = useState([]);
  const [coordinates, setCoordinates] = useState({ lat: '', lng: '' });

  // Definisci l'elenco dei comuni direttamente qui
  const comuniDisponibili = [
    { nome: 'Monopoli' },
    { nome: 'Alberobello' },
    { nome: 'Polignano a Mare' },
  ];

  // Esegui la chiamata REST al caricamento del componente per ottenere le categorie
  useEffect(() => {
    fetchCategorie();
  }, []);

  const fetchCategorie = async () => {
    try {
      const response = await axios.get(BASE_URL + '/util/aziende/category');
      setCategorie(response.data);
    } catch (error) {
      console.error('Errore durante il recupero delle categorie:', error);
    }
  };

  const onSubmit = async (data) => {
    try {
      // Aggiungi le coordinate al payload
      data.latitudine = coordinates.lat;
      data.longitudine = coordinates.lng;

      const response = await axios.post(BASE_URL + '/azienda', data, {
        headers: {
          'Authorization': `Bearer ` + sessionStorage.getItem('accessToken')
        }
      });
      toast.success('Utente creato con successo!');
    } catch (error) {
      toast.error('Errore durante la creazione dell\'utente.');
    }
  };

  const handleLatitudeChange = (event) => {
    const { value } = event.target;
    const isValidInput = /^[0-9.]*$/.test(value);
    if (isValidInput || value === '') {
      setCoordinates({ ...coordinates, lat: value });
    }
  };

  const handleLongitudeChange = (event) => {
    const { value } = event.target;
    const isValidInput = /^[0-9.]*$/.test(value);
    if (isValidInput || value === '') {
      setCoordinates({ ...coordinates, lng: value });
    }
  };

  const updateCoordinates = async (indirizzo, comune) => {
    if (!comune || !indirizzo) {
      setCoordinates({ lat: '', lng: '' });
      return;
    }
    const address = `${indirizzo}, ${comune}`;
    const coords = await getCoordinates(address);
    if (coords) {
      setCoordinates(coords);
    } else {
      setCoordinates({ lat: '', lng: '' });
    }
  };

  const handleAddressChange = (event) => {
    const indirizzo = event.target.value;
    const comuneSelezionato = event.target.form.comune.value;
    updateCoordinates(indirizzo, comuneSelezionato);
  };

  const handleCityChange = (event) => {
    const comuneSelezionato = event.target.value;
    const indirizzo = event.target.form.indirizzo.value;
    updateCoordinates(indirizzo, comuneSelezionato);
    // Aggiorna il valore del campo 'comune' nel form state
    setValue('comune', comuneSelezionato);
  };

  return (
    <div>
      <h2>Crea Utente</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label>Nome titolare*</label>
          <input type="text" {...register('nome', { required: true })} />
          {errors.nome && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Cognome titolare*</label>
          <input type="text" {...register('cognome', { required: true })} />
          {errors.cognome && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Denominazione azienda*</label>
          <input type="text" {...register('nomeAzienda', { required: true })} />
          {errors.nomeAzienda && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Indirizzo*</label>
          <input type="text" {...register('indirizzo', { required: true })} onBlur={handleAddressChange} />
          {errors.indirizzo && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Comune*</label>
          <select {...register('comune', { required: true })} onChange={handleCityChange}>
            <option value="">Seleziona un comune</option>
            {comuniDisponibili.map((comune) => (
              <option key={comune.nome} value={comune.nome}>{comune.nome}</option>
            ))}
          </select>
          {errors.comune && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Latitudine*</label>
          <input type="text" {...register('latitudine')} value={coordinates.lat} onChange={handleLatitudeChange} readOnly />
        </div>
        <div>
          <label>Longitudine*</label>
          <input type="text" {...register('longitudine')} value={coordinates.lng} onChange={handleLongitudeChange} readOnly />
        </div>
        <div>
          <label>Email*</label>
          <input type="text" {...register('email', { required: true })} />
          {errors.email && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Partita IVA*</label>
          <input type="text" {...register('partitaIva', { required: true })} />
          {errors.partitaIva && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Ragione Sociale*</label>
          <input type="text" {...register('ragioneSociale', { required: true })} />
          {errors.ragioneSociale && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <div>
          <label>Categoria*</label>
          <select {...register('categoria', { required: true })}>
            {categorie.map((cat, index) => (
              <option key={index} value={cat.code}>{cat.descrizione}</option>
            ))}
          </select>
          {errors.categoria && <span className="error-message">Campo obbligatorio</span>}
        </div>
        <button type="submit">Crea Utente</button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default CreaUtente;